import { makeStyles } from '@material-ui/core';
import { Colors } from '../../constants';
import { BUTTON_SIZE } from '../../containers/Widget/position';

export default makeStyles((theme) => ({
  button: {
    height: BUTTON_SIZE,
    width: BUTTON_SIZE,
    background: `linear-gradient(45deg,${Colors.primary} 30%,${Colors.primaryGradient} 70%,${Colors.secondary} 90%)`,
    color: Colors.white,
    zIndex: 1300,
    padding: theme.spacing(1.5),
    cursor: 'grab',
    touchAction: 'none',

    '&:active': {
      cursor: 'grabbing',
    },

    '& svg': {
      height: 24,
      width: 28,
    },
  },
  dragging: {
    cursor: 'grabbing',
  },
  tooltip: {
    fontSize: 12,
  },
}));
